import { useContext } from 'react';
import type { LoadPowattorneyServiceApi } from '@pa-api/pa-logic-load-document';
import ApiContext from '../components/ApiProvider/ApiContext';

export default function usePowAttorneyLoadDocumentApiClient(): LoadPowattorneyServiceApi {
  const { powAttorneyLoadDocumentApi } = useContext(ApiContext);

  return powAttorneyLoadDocumentApi;
}
